import { heroMeta } from "@/mocks/freegua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20still%20life%20of%20watermelon%20slices%2C%20popcorn%20and%20sparkling%20citrus%20on%20a%20cream%20cream%20surface%2C%20soft%20morning%20light%20with%20gentle%20shadows%2C%20beige%20background%2C%20playful%20casual%20entertainment%20mood%2C%20clean%20cozy%20composition%2C%20high%20detail%20editorial%20photography&width=1600&height=900&seq=gua-hero-bg&orientation=landscape"
          alt="免费吃瓜素材展示配图"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/55 to-background-100" />
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-32 text-center md:px-6 md:pb-24 md:pt-40">
        <span className="rise delay-1 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm font-medium text-primary-700">
          <i className="ri-flashlight-line" aria-hidden="true" />
          免费吃瓜无门槛 · 直接看不设会员
        </span>

        <h1 className="rise delay-2 mt-6 max-w-4xl font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-tight">
          免费吃瓜<span className="text-primary-600">零元看</span>
          <br className="hidden md:block" />
          所有热门素材，点开就有的看
        </h1>

        <p className="rise delay-3 mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          不用付费也不用开会员，整理好的截图、时间线、后续回应从头看到尾。
          <br className="hidden md:block" />
          不收藏也能随时回来看，真正不花钱、不注册。
        </p>

        <div className="rise delay-4 mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#today"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-eye-line mr-2" aria-hidden="true" />
            免费吃瓜直接看
          </a>
          <a
            href="#follow"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-300 bg-background-50/90 px-7 py-3.5 text-base font-bold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto"
          >
            先看持续跟进的瓜
            <i className="ri-arrow-right-line ml-2" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-9 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4">
          {heroMeta.map((m) => (
            <div
              key={m.text}
              className="flex items-center justify-center gap-2 rounded-xl border border-background-200/70 bg-background-50/80 px-3 py-3"
            >
              <i className={`${m.icon} text-accent-600`} aria-hidden="true" />
              <span className="whitespace-nowrap text-sm font-semibold text-foreground-800">{m.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}